import { create } from 'zustand';

import { UserDto } from '~modules/user/model';

export type AddStoreState = {
	user: UserDto | null;
	photo: string | null;
	is_part_time: boolean;
	setUser: (val: UserDto | null) => void;
	setPhoto: (val: string | null) => void;
	clearPhoto: () => void;
	errors: { [key: string]: string | null };
	clearErrors: () => void;
	setError: (key: string, value: string | null) => void;
	clear: () => void;
	setPartTime: (val: boolean) => void;
};

export const addStore = create<AddStoreState>((set, get) => ({
	isPending: false,
	user: null,
	photo: null,
	is_part_time: false,
	errors: {},
	setUser: (val: UserDto | null) => {
		set({ user: val, errors: { ...get().errors, user: null } });
	},
	setPhoto: (val: string | null) => {
		set({ photo: val, errors: { ...get().errors, photo: null } });
	},
	clearPhoto: () => set({ photo: null, errors: { ...get().errors, photo: null } }),
	clearErrors: () => set({ errors: {} }),
	setError: (key, value) => set({ errors: { ...get().errors, [key]: value } }),
	clear: () => set({ user: null, photo: null, errors: {}, is_part_time: false }),
	setPartTime: val => set(old => ({ ...old, is_part_time: val })),
}));
